<template>
  <InfoModal
    title="Tack för din komplettering"
    mobile-full-width
    abort-label="Stäng"
    @click="$emit('click')"
  >
    <div class="body">
      <p>
        Vi har tagit emot din komplettering. Våra handläggare kommer att se över
        dina uppgifter och återkoppla så snart som möjligt.
      </p>
    </div>
  </InfoModal>
</template>
<script>
import InfoModal from '@/components/InfoModal.vue';

export default {
  components: {
    InfoModal
  }
};
</script>
<style scoped lang="scss">
p {
  font-size: 1.6rem;
  margin-bottom: 2rem;
  line-height: 1.6;
  font-weight: 400;
  color: var(--color-dark);
  max-width: none;
}

.body {
  max-width: 600px;
}
</style>
